import "../css/loading.css";
import React from "react";

const Loader = () => (
  <div className="mainCss">
    <div className="dotsCss">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  </div>
);
export default Loader;
